import { useEffect, useState } from "react";
import Upiimg from '../assets/images/upipng.png'
import Net from '../assets/images/netBankingpng.png'
import Qr from '../assets/images/qur.png'
import TetherImg from '../assets/images/Tether.png';
import { Link, useNavigate } from "react-router-dom";


function Bank() {

    // Default selected option and image
    const [selectedOption, setSelectedOption] = useState<string>('option1');
    const [selectedImage, setSelectedImage] = useState<string>(Upiimg);

    // This effect is used to set the default values when the component mounts
    useEffect(() => {
        setSelectedOption('option1');
        setSelectedImage(Upiimg);
    }, []);

    const handleSelectOption = (value: string, imageSrc: string) => {
        setSelectedOption(value);
        setSelectedImage(imageSrc);
    };
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1); // Go back to the previous page
    };

    return (
        <section className="BanlScreen">
            <div className="container">
                <div className="row">
                    <div className="col-12 p-0">
                        <button className="backPayment" onClick={goBack}>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 42 42" fill="none">
                                    <path d="M18.9497 21.0012L27.6119 29.6632L25.137 32.138L14 21.0012L25.137 9.86426L27.6119 12.3391L18.9497 21.0012Z" fill="white" />
                                </svg>
                            </span>
                            Back
                        </button>
                    </div>
                </div>
            </div>
            <div className="container upiScreen">
                <div className="row upiScreenSelectedMethod depositWe">
                    <div className='depWithdrawal p-0'>
                        <Link to="/deposit">
                            <button className='active'>Deposit</button>
                        </Link>
                        <Link to="/withdrawal">
                            <button>Withdrawal</button>
                        </Link>
                    </div>
                    <label className="dropdownLabel p-0">Selected Method</label>
                    <div className="dropdown p-0">
                        {/* Button with the selected option and image */}
                        <button
                            className="btn btn-primary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {selectedImage && (
                                <img
                                    src={selectedImage}
                                    alt="Selected Option"
                                    style={{ width: 20, height: 20, marginRight: '8px' }}
                                />
                            )}
                            {selectedOption === 'option1'
                                ? 'Upi'
                                : selectedOption === 'option2'
                                    ? 'Bank'
                                    : selectedOption === 'option3'
                                        ? 'Qr'
                                        : 'Tether'}

                        </button>
                        <ul className="dropdown-menu">
                            {/* Dropdown Item 1 */}
                            <li onClick={() => handleSelectOption('option1', Upiimg)}>
                                <a className="dropdown-item" href="#">
                                    <img
                                        src={Upiimg}
                                        alt="Option 1"
                                        className="me-2"
                                        style={{ width: 20, height: 20 }}
                                    />
                                    UPI
                                </a>
                            </li>
                            {/* Dropdown Item 2 */}
                            <li onClick={() => handleSelectOption('option2', Net)}>
                                <a className="dropdown-item" href="#">
                                    <img
                                        src={Net}
                                        alt="Option 2"
                                        className="me-2"
                                        style={{ width: 20, height: 20 }}
                                    />
                                    Bank
                                </a>
                            </li>
                            {/* Dropdown Item 3 */}
                            <li onClick={() => handleSelectOption('option3', Qr)}>
                                <a className="dropdown-item" href="#">
                                    <img
                                        src={Qr}
                                        alt="Option 3"
                                        className="me-2"
                                        style={{ width: 20, height: 20 }}
                                    />
                                    QR
                                </a>
                            </li>
                            <li onClick={() => handleSelectOption('option4', TetherImg)}>
                                <a className="dropdown-item" href="#">
                                    <img
                                        src={TetherImg}
                                        alt="Option 3"
                                        className="me-2"
                                        style={{ width: 20, height: 20 }}
                                    />
                                    Tether
                                </a>
                            </li>
                        </ul>
                    </div>
                    {/* {selectedOption === 'option1' && (
                       <p></p>
                    )}

                    {selectedOption === 'option2' && (
                        <p></p>
                    )}

                    {selectedOption === 'option3' && (
                        <p></p>
                    )}
                    {selectedOption === 'option4' && (
                        <p></p>
                    )} */}
                </div>
                <div className="row">
                    {/* <div className="col-12">
                        <div className="d-flex align-items-center justify-content-center">
                            <p className="payheding">Amount Payable</p>
                            <h1 className="payAmout">₹100</h1>
                        </div>
                        <p className="depositDetal">Kindly  Deposit your amount on the given Bank details :</p>
                    </div> */}
                    <div className="col-12 mt-2 bankDetal">
                        <div className="row">
                            <div className="col-12 my-mb">
                                <label className="mt-0">Amount Payable</label>
                                <div className="inputBank">
                                    <input className="trxId" type="text" placeholder='₹100' />
                                    <button>
                                        <svg height="20" viewBox="0 0 24 24" width="24" fill="#94A3B8" xmlns="http://www.w3.org/2000/svg"><path d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z" /><path d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" /></svg>
                                    </button>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 my-mb">
                                <label>Holder Name</label>
                                <div className="inputBank">
                                    <input className="trxId" type="text" placeholder='John Smith' />
                                    <button>
                                        <svg height="20" viewBox="0 0 24 24" width="24" fill="#94A3B8" xmlns="http://www.w3.org/2000/svg"><path d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z" /><path d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" /></svg>
                                    </button>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 my-mb">
                                <label>Account Number</label>
                                <div className="inputBank">
                                    <input className="trxId" type="text" placeholder='1234544576987654' style={{ letterSpacing: '1px' }} />
                                    <button>
                                        <svg height="20" viewBox="0 0 24 24" width="24" fill="#94A3B8" xmlns="http://www.w3.org/2000/svg"><path d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z" /><path d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" /></svg>
                                    </button>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 my-mb">
                                <label>IFSC Code</label>
                                <div className="inputBank">
                                    <input className="trxId" type="text" placeholder='INDS5621' style={{ letterSpacing: '1px' }} />
                                    <button>
                                        <svg height="20" viewBox="0 0 24 24" width="24" fill="#94A3B8" xmlns="http://www.w3.org/2000/svg"><path d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z" /><path d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" /></svg>
                                    </button>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 my-mb">
                                <label>Bank Name</label>
                                <div className="inputBank">
                                    <input className="trxId" type="text" placeholder='HDFC Bank' />
                                    <button>
                                        <svg height="20" viewBox="0 0 24 24" width="24" fill="#94A3B8" xmlns="http://www.w3.org/2000/svg"><path d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z" /><path d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" /></svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 screenShotSec p-0 my-mb">
                            <label>Submit UTR Manually <sup style={{ color: '#F75653' }}>*</sup></label>
                            <input className="trxId" type="text" placeholder='Enter UTR (12 digit UPI Request' />
                            <label className="mt-3">Upload Transaction Screenshot <sup style={{ color: '#F75653' }}>*</sup></label>
                            <div className="uplodScreenBtn">
                                <svg className="uplodWeb" width="80" height="70" viewBox="0 0 90 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="89.8876" height="80" rx="3.59551" fill="#314A55" fillOpacity="0.78" />
                                    <rect x="0.449438" y="0.449438" width="88.9888" height="79.1011" rx="3.14607" stroke="#F8F8F8" strokeOpacity="0.1" strokeWidth="0.898876" strokeDasharray="3.8 3.8" />
                                    <g opacity="0.2">
                                        <path d="M66.6693 13.7528H23.3337C19.8406 13.7528 17 16.5924 17 20.0897V59.9177C17 63.4108 19.8406 66.2475 23.3337 66.2475H66.6691C70.1622 66.2475 72.9998 63.4108 72.9998 59.9177V20.0897C73 16.5924 70.1624 13.7528 66.6693 13.7528ZM53.2124 23.177C56.5905 23.177 59.33 25.9167 59.33 29.2945C59.33 32.6724 56.5903 35.4121 53.2124 35.4121C49.8335 35.4121 47.0949 32.6724 47.0949 29.2945C47.0949 25.9167 49.8335 23.177 53.2124 23.177ZM64.683 60.3927H26.1929C24.5033 60.3927 23.7508 59.1703 24.5125 57.6622L35.0114 36.8672C35.7721 35.3593 37.2219 35.2247 38.2486 36.5663L48.8056 50.3626C49.8323 51.7045 51.6269 51.8186 52.8147 50.6165L55.3973 48.0012C56.5841 46.799 58.3327 46.9479 59.3013 48.3315L65.989 57.8843C66.9557 59.27 66.3725 60.3927 64.683 60.3927Z" fill="white" />
                                    </g>
                                </svg>
                                <div className="ms-3">
                                    <h6>
                                        <svg className="me-2" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                            <g clipPath="url(#clip0_683_5092)">
                                                <path d="M13.9899 13.9899L10.4924 10.4924L6.99496 13.9899" stroke="white" strokeWidth="1.00889" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M10.4922 10.4924V18.3618" stroke="white" strokeWidth="1.00889" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M17.8284 16.0796C18.6812 15.6147 19.3549 14.879 19.7431 13.9887C20.1314 13.0984 20.2121 12.1041 19.9725 11.1628C19.7329 10.2215 19.1867 9.38679 18.42 8.79041C17.6534 8.19404 16.7099 7.86995 15.7386 7.86931H14.6369C14.3722 6.84564 13.879 5.89528 13.1942 5.08969C12.5093 4.28409 11.6508 3.64423 10.6831 3.2182C9.71539 2.79217 8.6637 2.59106 7.60708 2.62999C6.55046 2.66892 5.51642 2.94687 4.58269 3.44296C3.64896 3.93905 2.83984 4.64036 2.21616 5.49416C1.59248 6.34796 1.17048 7.33204 0.981866 8.37242C0.793256 9.41279 0.842951 10.4824 1.12722 11.5008C1.41148 12.5192 1.92292 13.4599 2.62308 14.2522" stroke="white" strokeWidth="1.00889" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M13.9899 13.9899L10.4924 10.4924L6.99496 13.9899" stroke="white" strokeWidth="1.00889" strokeLinecap="round" strokeLinejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_683_5092">
                                                    <rect width="20.9849" height="20.9849" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        Select and Uplaod files
                                    </h6>
                                    <p>Supported formates: JPEG, PNG, JPEG, PDF</p>
                                </div>
                                <input type="file" style={{ opacity: '0' }} />
                            </div>
                            <button>DEPOSIT</button>
                        </div>
                        <div className="col-12 mt-2">
                            <h3 className="text-white mt-2">Quick Guide 🔥 </h3>
                            <p style={{ fontSize: 12, color: '#ccc', opacity: '0.7' }}>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                            </p>
                        </div>
                    </div>


                </div>
            </div>
        </section>
    )
}
export default Bank;